import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { services } from "@/data/services";

export default function Footer() {
  return (
    <footer className="noise-overlay bg-ink text-paper" data-testid="site-footer">
      <div className="relative z-10 mx-auto max-w-[1600px] px-6 lg:px-12 pt-24 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-20 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="inline-flex bg-paper px-5 py-4 mb-10">
              <img
                src="/logo.png"
                alt="KC Consultancy"
                className="h-24 w-auto object-contain"
              />
            </div>
            <p className="mt-6 font-display text-3xl sm:text-4xl leading-tight">
              Independent insight.
              <br />
              <span className="text-brand">Practical improvement.</span>
            </p>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-paper/60">
              Specialist Youth Justice consultancy supporting services across
              England &amp; Wales.
            </p>
          </div>

          <div className="md:col-span-2">
            <p className="font-mono text-[10px] tracking-[0.22em] uppercase text-paper/40 mb-6">
              Explore
            </p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="link-underline text-paper/70 hover:text-paper" data-testid="footer-link-home">Home</Link></li>
              <li><Link to="/services" className="link-underline text-paper/70 hover:text-paper" data-testid="footer-link-services">Services</Link></li>
              <li><Link to="/about" className="link-underline text-paper/70 hover:text-paper" data-testid="footer-link-about">About</Link></li>
              <li><Link to="/contact" className="link-underline text-paper/70 hover:text-paper" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="font-mono text-[10px] tracking-[0.22em] uppercase text-paper/40 mb-6">
              Services
            </p>
            <ul className="space-y-3 text-sm">
              {services.map((s) => (
                <li key={s.id}>
                  <Link
                    to={`/services#${s.id}`}
                    className="text-paper/70 hover:text-paper transition-colors duration-300"
                    data-testid={`footer-service-${s.id}`}
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] tracking-[0.22em] uppercase text-paper/40 mb-6">
              Contact
            </p>
            <ul className="space-y-3 text-sm text-paper/70">
              <li>
                <a href="mailto:info@kcconsultancy.co.uk" className="link-underline hover:text-paper" data-testid="footer-email-link">
                  info@kcconsultancy.co.uk
                </a>
              </li>
              <li>
                <a href="tel:+447904805795" className="link-underline hover:text-paper" data-testid="footer-phone">
                  07904 805 795
                </a>
              </li>
              <li data-testid="footer-coverage">England &amp; Wales</li>
            </ul>
            <Link
              to="/contact"
              data-testid="footer-cta-button"
              className="mt-8 inline-flex items-center gap-2 rounded-full border border-paper/30 px-6 py-3 text-sm transition-colors duration-300 hover:border-brand hover:bg-brand"
            >
              Contact Us
              <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>
        </div>

        <div className="pt-8 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
          <div>
            <p className="font-mono text-[11px] tracking-wider text-paper/40" data-testid="footer-copyright">
              © 2026 KC Consultancy. All rights reserved.
            </p>
            <p className="mt-2 font-mono text-[11px] tracking-wider text-paper/40" data-testid="footer-legal-entity">
              KC Consultancy is the trading name of Kathleen Cullen Care Limited.
            </p>
            <p className="mt-2 font-mono text-[11px] tracking-wider text-paper/40" data-testid="footer-ico-registration">
              ICO registration reference: C2040968
            </p>
          </div>
          <nav className="flex flex-wrap gap-6" data-testid="footer-legal-links">
            <Link to="/privacy" className="font-mono text-[11px] tracking-wider text-paper/40 hover:text-paper transition-colors duration-300" data-testid="footer-link-privacy">
              Privacy Policy
            </Link>
            <Link to="/cookies" className="font-mono text-[11px] tracking-wider text-paper/40 hover:text-paper transition-colors duration-300" data-testid="footer-link-cookies">
              Cookie Policy
            </Link>
            <Link to="/terms" className="font-mono text-[11px] tracking-wider text-paper/40 hover:text-paper transition-colors duration-300" data-testid="footer-link-terms">
              Terms of Use
            </Link>
          </nav>
          <p className="font-mono text-[11px] tracking-wider text-paper/40">
            Independent insight. Practical improvement.
          </p>
        </div>
      </div>
    </footer>
  );
}
